module.exports = __webpack_public_path__ + "img/afb8633.svg";